import { render, staticRenderFns } from "./EpisodesSection.vue?vue&type=template&id=487ccfb0&"
import script from "./EpisodesSection.vue?vue&type=script&lang=js&"
export * from "./EpisodesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports